import { createReducer, on } from '@ngrx/store';
import * as TaskActions from './task.actions';
import { initialState } from './task.state';
// Ensure Task model is imported

export const taskReducer = createReducer(
  initialState,

  // Create Task
  on(TaskActions.createTask, (state) => ({ ...state, loading: true, error: null })),
  on(TaskActions.createTaskSuccess, (state, { task }) => ({
    ...state,
    // Add to opportunityTasks list, maybe clear currentTask or set it? Let's just add to list for now.
    opportunityTasks: [...state.opportunityTasks, task],
    loading: false,
  })),
  on(TaskActions.createTaskFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // Load Tasks for an Opportunity
  on(TaskActions.loadTasksByOpportunity, (state) => ({
    ...state,
    opportunityTasks: [], // Clear previous opportunity tasks
    loading: true,
    error: null,
  })),
  on(TaskActions.loadTasksSuccess, (state, { tasks }) => ({
    ...state,
    opportunityTasks: tasks, // Populate the list for the current opportunity
    loading: false,
  })),
  on(TaskActions.loadTasksFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // Load Single Task - Sets the currentTask
  on(TaskActions.loadTask, (state) => ({ ...state, currentTask: null, loading: true, error: null })),
  on(TaskActions.loadTaskSuccess, (state, { task }) => {
    // Also update the task within the opportunityTasks list if it exists
    const index = state.opportunityTasks.findIndex((t) => t.id === task.id);
    const newOpportunityTasks = [...state.opportunityTasks];
    if (index >= 0) {
      newOpportunityTasks[index] = task;
    }
    // Set the current task being viewed/edited
    return { ...state, opportunityTasks: newOpportunityTasks, currentTask: task, loading: false };
  }),
  on(TaskActions.loadTaskFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // Update Task
  on(TaskActions.updateTask, (state) => ({ ...state, loading: true, error: null })),
  on(TaskActions.updateTaskSuccess, (state, { task }) => ({
    ...state,
    // Update the task in the opportunity list
    opportunityTasks: state.opportunityTasks.map((t) => (t.id === task.id ? task : t)),
    // Update currentTask if it's the one being edited
    currentTask: state.currentTask?.id === task.id ? task : state.currentTask,
    loading: false,
  })),
  on(TaskActions.updateTaskFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // Delete Task
  on(TaskActions.deleteTask, (state, { id: _id }) => ({ ...state, loading: true, error: null })),
  on(TaskActions.deleteTaskSuccess, (state, { id }) => ({
    ...state,
    // Remove from the opportunity list
    opportunityTasks: state.opportunityTasks.filter((t) => t.id !== id),
    // Clear currentTask if it's the one being deleted
    currentTask: state.currentTask?.id === id ? null : state.currentTask,
    loading: false,
  })),
  on(TaskActions.deleteTaskFailure, (state, { error }) => ({ ...state, loading: false, error }))

  // Remove Select Task handler - No longer needed
  // on(TaskActions.selectTask, (state, { id }) => ({ ...state, selectedTaskId: id }))
);
